var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getContentBlockType.component,{tag:"component",attrs:{"is-loading":_vm.isLoading},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }